import React from 'react'
import './Button.css'

function Button() {
    return (
        <div>
            
        </div>
    )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/default/Button/Button.js